import React, { FC, ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

interface AppLayoutProps {
  children: ReactNode;
  className?: string;
}

const AppLayout: FC<AppLayoutProps> = ({ children, className }) => {
  return (
    <div className="flex flex-col min-h-screen mb-0">
      <Navbar />
      <main className={`${className} mt-20 md:mt-28 mb-10 flex-grow`}>{children}</main>
      <Footer />
    </div>
  );
};

export default AppLayout;
